import { useState } from 'react';
import { useDatos } from '../../datos/DatosContext';
import { useRuta } from '../../lib/ruta';
import { useAviso } from '../../lib/avisos';
import { Icono } from '../../componentes/ui/Icono';
import { Cabecera, Demo, GrupoChips } from '../../componentes/ui/basicos';
import type { ElementoBiblioteca } from '../../modelo/tipos';

/** Estado del material de cara a la IA. */
export function estadoMaterial(el: ElementoBiblioteca): { texto: string; clase: string } {
  if (!el.permitirIA) return { texto: 'Sin permiso de IA', clase: 'tag' };
  if (el.tipoMaterial !== 'ninguno') return { texto: 'Material accesible para la IA', clase: 'tag moss' };
  return { texto: 'Solo enlace: sin contenido accesible', clase: 'tag warn' };
}

export function Biblioteca() {
  const { datos } = useDatos();
  const { ir } = useRuta();
  const aviso = useAviso();
  const [consulta, setConsulta] = useState('');
  const [tipo, setTipo] = useState('Todos');
  const q = consulta.trim().toLowerCase();
  const lista = datos.biblioteca.filter((b) => (tipo === 'Todos' || b.tipo === tipo) && (!q || (b.titulo + ' ' + b.autor).toLowerCase().includes(q)));

  return (
    <div className="stack-lg">
      <Cabecera
        antetitulo="Seguir aprendiendo"
        titulo="Biblioteca"
        accion={<button className="btn" onClick={() => aviso('Solo visual: aquí se abrirá el formulario para añadir un libro, podcast, curso…')}><Icono nombre="plus" />Añadir <Demo /></button>}
      />
      <div className="searchbox">
        <Icono nombre="search" />
        <label htmlFor="bq" className="sr">Buscar en la biblioteca</label>
        <input id="bq" type="search" placeholder="Título o autor…" value={consulta} onChange={(e) => setConsulta(e.target.value)} />
      </div>
      <GrupoChips etiqueta="Tipo de contenido" opciones={['Todos', ...datos.opciones.tiposBiblioteca]} seleccion={tipo} onElegir={setTipo} desplazable />
      <div className="grid2">
        {lista.map((b) => {
          const m = estadoMaterial(b);
          return (
            <button key={b.id} className="listbtn" onClick={() => ir('/biblioteca/' + b.id)}>
              <span className="between"><span className="tag">{b.tipo}</span><span className="muted small">{b.estado}</span></span>
              <span className="display" style={{ fontSize: 21 }}>{b.titulo}</span>
              <span className="muted small">{b.autor}</span>
              <span className={m.clase}>{m.texto}</span>
            </button>
          );
        })}
      </div>
      {!lista.length ? <p className="muted">Nada coincide con la búsqueda.</p> : null}
    </div>
  );
}
